/// <reference path="../../../scripts/typings/crew.d.ts" />

import { Component, OnInit } from '@angular/core';
import { MenuDataService } from "../core/menu.dataservice";
import { MenuItem } from "../model/menu.item";
import { CrewEventManager } from '../shared/event-manager.service';

@Component({
    selector: 'crew-home',
    template: require('./home.component.html')
})
export class Home implements OnInit {

    menu: MenuItem[];

    constructor(
        private menuDataService: MenuDataService,
        eventManager: CrewEventManager) {
        eventManager.onAuthenticationSuccess(() => this.ngOnInit());
    }

    ngOnInit(): void {
        this.menuDataService.getMenuItems().subscribe(
            menuItems => this.menu = this.createMenu(menuItems),
            () => { });
    }

    private createMenu(menuItems: MenuItem[]): MenuItem[] {
        return menuItems.map(item => {
            if (item.hasChildren) {
                const uiSref = item.childMenuItems[0].uiSref;
                return new MenuItem(item.title, item.icon, uiSref);
            } else {
                return item;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/home/home.component.ts